import {VersionVariants} from '@jobseeker/lotus/enums';
import {TextFieldProps as MuiTextFieldProps} from '@mui/material';
import {memo} from 'react';
import V1 from './V1';
import V2 from './V2';
import V3 from './V3';

type MuiProps = Pick<
  MuiTextFieldProps,
  | 'InputProps'
  | 'label'
  | 'defaultValue'
  | 'type'
  | 'id'
  | 'name'
  | 'value'
  | 'onChange'
  | 'error'
  | 'helperText'
  | 'size'
  | 'placeholder'
  | 'sx'
  | 'onInput'
  | 'onPaste'
  | 'inputProps'
  | 'id'
  | 'autoFocus'
  | 'fullWidth'
  | 'onKeyDown'
  | 'focused'
  | 'ref'
  | 'onClick'
  | 'inputRef'
  | 'autoComplete'
  | 'autoCorrect'
  | 'spellCheck'
  | 'onFocus'
  | 'onBlur'
  | 'disabled'
>;

export interface TextFieldProps extends MuiProps {
  variant: string | VersionVariants;
  hirist?: boolean;
}

let componentMap: {[key: string]: any} = {};

componentMap[VersionVariants.VERSION_ONE] = V1;
componentMap[VersionVariants.VERSION_TWO] = V2;
componentMap[VersionVariants.VERSION_THREE] = V3;

const Component = (props: TextFieldProps) => {
  const SelectedComponent =
    componentMap[props.variant] || componentMap[VersionVariants.VERSION_ONE];
  return <SelectedComponent {...props} />;
};

export default memo(Component);
